<template>
  <v-container>
    <v-card style="padding: 5px; border-radius: 3px" elevation="1">
      <v-toolbar style="box-shadow: none;">
        <v-row wrap>
          <v-col class="col-12" sm="12" md="12">
            <v-row wrap>
              <v-col class="col-10 reg__custom__flex" sm="10" md="10">
                <v-text-field
                  v-model="search"
                  @input="searchContents"
                  prepend-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col class="col-2 reg__custom__flex" sm="2" md="2">
                <v-menu
                  :nudge-bottom="14"
                  v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'"
                  offset-y
                  origin="center center"
                  class="elelvation-1"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on }"
                    ><v-btn v-on="on" icon>
                      <v-icon medium class="black--text">more_vert</v-icon>
                    </v-btn></template
                  >
                  <v-list single-line class="pa-0">
                    <v-list-item
                      v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'"
                      @click="selectAll"
                      avatar
                    >
                      <v-list-item-avatar>
                        <v-icon medium dark color="primary">check_box</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-sub-title>
                          Select all
                        </v-list-item-sub-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item
                      @click="bulkDeleteShifts"
                      v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'"
                      avatar
                    >
                      <v-list-item-avatar>
                        <v-icon medium dark color="primary">delete_sweep</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-sub-title>
                          Batch delete
                        </v-list-item-sub-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-toolbar>
    </v-card>

    <v-layout row wrap>
      <v-flex xs12 sm12 md12 style="padding: 10px">
        <div v-if="shiftContents.length > 0" style="border-radius: 2px; box-shadow: none;">
          <DisplayCard
            v-if="renderComponent"
            :renderData="shiftContents"
            @deleteData="deleteItem"
            @editData="editItem"
            @selectDataIds="BulkDeleteIds"
            :selectAll="selectAllData"
          ></DisplayCard>
        </div>

        <div v-else align="center">
          <v-nodata
            :loading="loading.shiftOption"
            :networkError="networkError.shiftOption"
            @retryMethod="getShiftData"
            title=""
            msg-details="You haven't added any shifts yet"
            icon="checkinguy"
          >
          </v-nodata>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialog"
      :fullscreen="$mq == 'mobile' ? true : false"
      max-width="600px"
      persistent
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="canSee('modifyShifts')"
          v-on="on"
          color="primary"
          dark
          fixed
          bottom
          right
          fab
          direction="top"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>

      <v-card elevation="2" style="border-radius: 3px">
        <v-card-title class="primary">
          <h4 class="reg__heading">{{ formTitle }}</h4>
          <v-spacer></v-spacer>
          <v-btn v-if="$mq == 'mobile'" @click="dialog = false" icon fab small dark>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-5">
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <v-text-field
                ref="shiftRules"
                v-model="editedItem.name"
                :rules="shiftRules"
                prepend-icon="create"
                label="Shift Name"
              ></v-text-field>
            </v-flex>

            <v-row wrap>
              <v-flex xs12 sm6 md6 class="reg__custom__flex">
                <v-dialog
                  ref="dialog"
                  v-model="modal1"
                  :return-value.sync="editedItem.startTime"
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="editedItem.startTime"
                      prepend-icon="timer"
                      label="Start Time"
                    ></v-text-field>
                  </template>
                  <v-time-picker v-if="modal1" v-model="editedItem.startTime" full-width>
                    <v-spacer></v-spacer>
                    <v-btn @click="modal1 = false" color="primary">Cancel</v-btn>
                    <v-btn @click="$refs.dialog.save(editedItem.startTime)" color="primary"
                      >OK</v-btn
                    >
                  </v-time-picker>
                </v-dialog>
              </v-flex>

              <v-flex xs12 sm6 md6 class="reg__custom__flex">
                <v-dialog
                  ref="dialog1"
                  v-model="modal2"
                  :return-value.sync="editedItem.endTime"
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="editedItem.endTime"
                      prepend-icon="timer_off"
                      label="End Time"
                    ></v-text-field>
                  </template>
                  <v-time-picker v-if="modal2" v-model="editedItem.endTime" full-width>
                    <v-spacer></v-spacer>
                    <v-btn @click="modal2 = false" color="primary">Cancel</v-btn>
                    <v-btn @click="$refs.dialog1.save(editedItem.endTime)" color="primary"
                      >OK</v-btn
                    >
                  </v-time-picker>
                </v-dialog>
              </v-flex>
            </v-row>

            <v-row wrap>
              <v-flex xs12 sm12 md12 class="reg__custom__flex">
                <v-text-field
                  v-model="editedItem.bufferTime"
                  :rules="bufferRules"
                  prepend-icon="history"
                  label="Buffer Time(min)"
                  required
                ></v-text-field>
              </v-flex>
            </v-row>

            <v-flex xs12 sm12 md12 class="reg__custom__flex">
              <v-switch :label="`Specify Dates`" v-model="switch1" color="primary"></v-switch>
            </v-flex>

            <v-flex v-if="switch1" xs12 sm12 md12 class="reg__custom__flex">
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="40"
                :return-value.sync="dates"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-combobox
                    v-on="on"
                    v-model="dates"
                    multiple
                    chips
                    small-chips
                    label="Select Date"
                    prepend-icon="date_range"
                  ></v-combobox>
                </template>

                <v-date-picker v-model="dates" multiple no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn @click="menu = false || close" color="primary">Cancel</v-btn>
                  <v-btn @click="$refs.menu.save(dates)" color="primary">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex v-if="!switch1" xs12 sm12 md12 class="reg__custom__flex">
              <h3 style="text-align: left">All days except</h3>
              <v-layout row wrap align-center>
                <v-flex xs4 sm4 md5 class="reg__custom__flex">
                  <v-select
                    :items="dayData"
                    v-model="day"
                    :menu-props="{ maxHeight: '400' }"
                    label="Day"
                    item-text="display_name"
                    item-value="value"
                    required
                    style="font-size: 13px"
                  ></v-select>
                </v-flex>
                <v-flex xs5 sm5 md5 class="reg__custom__flex">
                  <v-select
                    :items="occurenceData"
                    v-model="occurence"
                    :menu-props="{ maxHeight: '400' }"
                    label="Occurrence"
                    multiple
                    item-text="display_name"
                    item-value="value"
                    required
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.display_name }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ occurence.length - 1 }})</span
                      >
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs2 sm2 md2 class="reg__custom__flex">
                  <v-btn
                    @click="addShift"
                    color="blue darken-1"
                    class="white--text"
                    style="text-transform: none"
                    >Add</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 md12 sm12>
              <v-card
                v-for="(item, i) in selectedDayOccurence"
                :key="i"
                elevation="0"
                style="margin: 5px; border-left: 7px solid #1976d2"
                outlined
              >
                <v-card-text style="padding: 5px 20px">
                  <v-layout row wrap>
                    <v-flex xs5 sm5 md5>
                      <h3 style="font-size: 14px !important; text-align: left; margin-top: 5px">
                        {{ getDayDisplayName(item.day) }}
                      </h3>
                    </v-flex>

                    <v-flex xs5 sm5 md5>
                      <h3 style="font-size: 14px !important; text-align: left; margin-top: 5px">
                        {{ _.join(getoccurenceDisplayName(item.occurence), ", ") }}
                      </h3>
                    </v-flex>

                    <v-flex xs2 sm2 md2 style="text-align: right">
                      <v-btn @click="removeShift(i)" icon ripple
                        ><v-icon color="error">delete</v-icon></v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>

            <h2
              style="font-size: 13px; font-weight: 500; color:#1a1a1a; margin-left: 10px; margin-top: 10px; margin-bottom: 10px"
            >
              Assigned Members
            </h2>

            <v-flex v-if="loader" xs12 sm12 md12 class="reg__custom__flex">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-flex>

            <v-flex
              v-else-if="assignes.length > 0 && formTitle == 'Edit'"
              xs12
              sm12
              md12
              class="reg__custom__flex"
              style="text-align: left !important"
            >
              <v-chip
                v-for="(user, index) in assignes"
                :key="index"
                class="ma-2"
                color="primary"
                text-color="white"
                label
              >
                <v-avatar left color="#fafafa" style="color: #1a1a1a">
                  {{ user.firstName.substring(0, 1) }}
                </v-avatar>
                {{ user.email }}
              </v-chip>
            </v-flex>

            <v-flex
              v-else-if="formTitle == 'New' || (assignes.length < 1 && formTitle == 'Edit')"
              xs12
              sm12
              md12
              style="padding: 0px 7px; text-align: left !important"
            >
              <v-alert border="left" colored-border elevation="2" dense color="orange">
                <h4
                  style="font-size: 12px; letter-spacing: 0.5px; font-weight: 500; color: #1a1a1a"
                >
                  Currently you dont have any members assigned to this shift, please
                  <a href="/#/members">visit</a> the member's page to assign.
                </h4>
              </v-alert>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="close" color="blue darken-1" text>Cancel</v-btn>
          <v-btn
            v-if="formTitle == 'New' && canSee('modifyShifts')"
            @click.native="save"
            color="primary"
            >Save</v-btn
          >
          <v-btn v-else-if="canSee('modifyShifts')" @click.native="save" color="primary"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="preLoader" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import canSee from "@/utilities/canSee";
import moment from "moment-timezone";
import VNodata from "@/components/Unavailable/nodata.vue";
import DisplayCard from "@/views/card.vue";
import fb from "@/utilities/firebase";

export default {
  components: { VNodata, DisplayCard },
  data: () => ({
    renderComponent: true,
    shiftContents: [],
    assignes: [],
    loader: false,
    preLoader: false,
    shiftRules: [
      v => !!v || "Shift Name is required",
      v => /^[A-Za-z0-9\-][a-zA-Z0-9 ]+[a-zA-Z0-9]*$/.test(v) || "Shift name should be valid."
    ],
    bufferRules: [v => /^[0-9]*$/.test(v) || "Buffer Time must be numeric"],

    selectAllData: false,

    loading: {
      shiftOption: true
    },
    networkError: {
      shiftOption: false
    },

    occurenceData: [
      { display_name: "1st", value: "1" },
      { display_name: "2nd", value: "2" },
      { display_name: "3rd", value: "3" },
      { display_name: "4th", value: "4" },
      { display_name: "5th", value: "5" }
    ],
    dayData: [
      { display_name: "Sunday", value: "0" },
      { display_name: "Monday", value: "1" },
      { display_name: "Tuesday", value: "2" },
      { display_name: "Wednesday", value: "3" },
      { display_name: "Thursday", value: "4" },
      { display_name: "Friday", value: "5" },
      { display_name: "Saturday", value: "6" }
    ],

    occurence: [],
    day: [],
    selectedDayOccurence: [],
    switch1: false,
    dates: [new Date().toISOString().substr(0, 10)],
    menu: false,
    dialog: false,
    setLoading: true,
    search: "",
    companyId: "",
    modal2: false,
    modal1: false,

    headers: [
      {
        text: "Name",
        align: "left",
        sortable: true,
        value: "name"
      },
      {
        text: "Start Time",
        align: "left",
        value: "startTime",
        sortable: false
      },
      {
        text: "End Time",
        align: "left",
        value: "endTime",
        sortable: false
      },
      {
        text: "Edit",
        align: "left",
        value: "edit",
        sortable: false
      },
      {
        text: "Delete",
        align: "left",
        value: "delete",
        sortable: false
      }
    ],
    shifts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      startTime: "",
      endTime: "",
      companyId: "",
      bufferTime: ""
    },
    defaultItem: {
      name: "",
      startTime: "",
      endTime: "",
      companyId: "",
      bufferTime: ""
    },
    page: 1,
    perPage: 2,
    pages: [],
    selectedShiftsId: []
  }),
  computed: {
    searchContents() {
      const self = this;
      self.renderComponent = false;
      _.each(self.shiftContents, f => {
        var re = new RegExp(self.search.toLowerCase(), "g");

        if (f.title.toLowerCase().match(re)) {
          f.visible = true;
        } else if (self.search == "") {
          f.visible = true;
        } else {
          f.visible = false;
        }

        self.$nextTick(() => {
          self.renderComponent = true;
        });
      });
    },

    formTitle() {
      return this.editedIndex === -1 ? "New" : "Edit";
    },
    pagination: {
      get: function() {
        if (this.$store.getters.pagination) {
          return this.$store.getters.pagination[this.$router.currentRoute.name];
        }
      },
      set: function(val) {
        this.$store.commit("setPagination", {
          name: this.$router.currentRoute.name,
          pagination: val
        });
      }
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },

    filters: {
      trimWords(value) {
        return (
          value
            .split(" ")
            .splice(0, 20)
            .join(" ") + "..."
        );
      }
    }
  },

  created() {
    this.getShiftData();

    this.editedItem.startTime = moment("10:00", "HH:mm").format("HH:mm");
    this.defaultItem.startTime = moment("10:00", "HH:mm").format("HH:mm");
    this.editedItem.endTime = moment("19:00", "HH:mm").format("HH:mm");
    this.defaultItem.endTime = moment("19:00", "HH:mm").format("HH:mm");
    this.editedItem.companyId = this.$store.state.userDetails.companyId;
    this.defaultItem.companyId = this.$store.state.userDetails.companyId;
  },
  methods: {
    BulkDeleteIds(ids) {
      this.selectedShiftsId = ids;
    },
    //bulk delete shifts
    bulkDeleteShifts() {
      if (this.selectedShiftsId.length < 1) {
        this.$swal({ type: "warning", text: "There is no selected members" });
        return;
      }

      const postObj = {
        ids: this.selectedShiftsId
      };

      this.$http.post(`${this.$store.state.endpoint}shifts/bulk/delete`, postObj).then(
        response => {
          this.selectedShiftsId = [];
          this.selectAllData = false;
          this.getShiftData();

          this.$swal({ type: "success", text: "Successfully deleted" });
        },
        error => {
          this.$swal({ type: "error", text: "Something went wrong" });
        }
      );
    },

    selectAll() {
      this.renderComponent = false;
      this.selectAllData = true;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    canSee(what, role, options) {
      return canSee(this, what, role, options);
    },

    getDayDisplayName(value) {
      const { dayData } = this;

      for (const o in dayData) {
        if (dayData[o].value == value) {
          return dayData[o].display_name;
        }
      }
    },
    getoccurenceDisplayName(occr) {
      const occrName = [];

      const { occurenceData } = this;
      for (const o in occurenceData) {
        for (const m in occr) {
          if (occurenceData[o].value == occr[m]) {
            occrName.push(occurenceData[o].display_name);
          }
        }
      }

      return occrName;
    },
    getOccurrenceName(occr) {
      const { occurenceData } = this;
      for (const o in occurenceData) {
        for (const m in occr) {
          if (occurenceData[o].value == occr[m]) {
            return occurenceData[o].display_name;
          }
        }
      }
    },
    addShift() {
      // var itemObj = this.editedItem

      if (this.editedItem.name == "") {
        this.$swal({
          type: "error",
          text: "Please select a Shift Name"
        });
        return;
      }

      if (this.day == "" || this.occurence == "") {
        this.$swal({
          type: "error",
          text: "Please select a day and a occurrence"
        });
        return;
      }

      // lets first get the list of days+occurence current selected
      const dummySelection = [...this.selectedDayOccurence];
      dummySelection.push({ day: this.day, occurence: this.occurence });
      // Check if dates are already there
      const alreadySelected = _.flattenDeep(
        _.map(dummySelection, h => _.map(h.occurence, o => `${h.day}_${o}`))
      );

      if (_.uniq(alreadySelected).length != alreadySelected.length) {
        this.$swal({
          type: "error",
          text: "There is already a similar day and occurrence"
        });
        return;
      }

      this.selectedDayOccurence.push({ day: this.day, occurence: this.occurence });
      this.day = "";
      this.occurence = "";
    },
    removeShift(item) {
      this.selectedDayOccurence.splice(item, 1);
    },

    BulkDeleteIds(ids) {
      this.selectedShiftsId = ids;
    },

    // Paginations

    // load all the shift details
    getShiftData() {
      this.loading.shiftOption = true;

      this.shifts = [];
      // this.setLoading = true

      this.$http
        .get(
          `${this.$store.state.endpoint}shifts?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            this.loading.shiftOption = false;

            this.shifts = response.body;
            var response = response.body;

            this.shiftContents = [];
            for (const x in response) {
              // for (const m in response[x].exceptions) {
              //   response[x].hasDay = this.getDayDisplayName(response[x].exceptions[m].day)
              //   response[x].hasOccurrence = '';
              //   for (let o = 0; o < response[x].exceptions[m].occurence.length; o++) {
              //     response[x].hasOccurrence += `${this.getOccurrenceName(response[x].exceptions[m].occurence[o])}  `;
              //   }
              // }

              var dayDisplayName = [];

              if (response[x].custom) {
                response[x].permissionType = "modifyShifts";
                response[x].title = response[x].name;
                response[x].visible = true;

                for (var y in response[x].customDates) {
                  dayDisplayName.push(response[x].customDates[y].slice(0, 10));
                }

                response[x].contents = {
                  Dates: _.join(dayDisplayName, ", "),
                  Start: response[x].startTime,
                  End: response[x].endTime
                };

                this.shiftContents.push(response[x]);
              } else {
                response[x].permissionType = "modifyShifts";
                response[x].title = response[x].name;
                response[x].visible = true;

                for (var y in response[x].customDates) {
                  dayDisplayName.push(response[x].customDates[y].slice(0, 10));
                }

                if (response[x].exceptions.length > 0) {
                  for (var y in response[x].exceptions) {
                    dayDisplayName.push(this.getDayDisplayName(response[x].exceptions[y].day));
                  }
                } else {
                  dayDisplayName.push("None");
                }

                response[x].contents = {
                  Day: _.join(dayDisplayName, ", "),
                  Start: response[x].startTime,
                  End: response[x].endTime
                };

                this.shiftContents.push(response[x]);
              }
            }
            this.preLoader = false;
            // this.setLoading = false
          },
          error => {
            console.log(error);
            this.preLoader = false;
            this.loading.shiftOption = false;
            this.networkError.shiftOption = true;
            //  this.setLoading = false
            // error callback
          }
        );
    },
    editItem(item) {
      this.editedIndex = this.shifts.indexOf(item);
      this.editedItem = Object.assign({}, item);

      const { custom } = item;

      if (custom) {
        this.switch1 = true;

        const customDates = [];

        const customDatesModify = item.customDates;

        for (const m in customDatesModify) {
          customDates.push(moment(customDatesModify[m]).format("YYYY-MM-DD"));
        }

        this.dates = customDates;
      } else {
        this.switch1 = false;

        this.dates = [];

        this.selectedDayOccurence = item.exceptions;
      }
      this.getAssignes(item.id);
      this.dialog = true;
    },

    getAssignes(id) {
      this.assignes = [];
      this.loader = true;
      this.$http
        .get(
          `${this.$store.state.endpoint}accounts?filter[where][companyId]=${this.$store.getters.userDetails.companyId}&filter[where][allowedShifts]=${id}`
        )
        .then(response => {
          this.assignes = response.body;
          this.loader = false;
        })
        .catch(err => {
          this.loader = false;
          console.log("err", TypeError);
        });
    },

    getDayDisplayName(value) {
      const { dayData } = this;

      for (const o in dayData) {
        if (dayData[o].value == value) {
          return dayData[o].display_name;
        }
      }
    },

    deleteItem(item) {
      const self = this;

      const itemObj = item.id;
      const index = self.shifts.indexOf(item);

      self
        .$swal({
          text: `Are you sure, you want to delete ${item.name}?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "info",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes"
        })
        .then(result => {
          if (result.value) {
            self.preLoader = true;
            self.$http.delete(`${self.$store.state.endpoint}shifts/${itemObj}`).then(
              response => {
                self.getShiftData();
              },
              error => {
                console.log(error);
                self.preLoader = false;
                // error callback
              }
            );
          }
        });
    },
    close() {
      this.dialog = false;
      this.selectedDayOccurence = [];
      this.day = "";
      this.occurence = "";
      this.dates = [];
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      const custom = this.switch1;
      this.preLoader = true;

      const customDatesModify = this.dates;

      let customDates = [];

      for (const m in customDatesModify) {
        customDates.push(`${moment(customDatesModify[m]).format("YYYY-MM-DDTHH:mm:ss")}.000Z`);
      }

      let exceptions;

      if (custom) {
        customDates = customDates;
        exceptions = [];
      } else {
        customDates = [];
        exceptions = this.selectedDayOccurence;
      }

      const itemObj = this.editedItem;

      if (itemObj.name == "") {
        // confirm("Please add a name")
        this.preLoader = false;
        this.$swal({
          type: "error",
          text: "Please add a shift name."
        });
        return;
      }

      /* if (itemObj.bufferTime == "") {
        this.$swal({
          type: "error",
          text: "Please add buffer time"
        });
        this.preLoader = false
        return;
      } */

      if (itemObj.bufferTime != "") {
        if (!/^[0-9]+$/.test(itemObj.bufferTime)) {
          this.$swal({
            type: "error",
            text: "Buffer time must be numeric"
          });
          this.preLoader = false;
          return;
        }
      }

      if (itemObj.name == "") {
        // confirm("Please add a name")
        this.$swal({
          type: "error",
          text: "Please add a shift name."
        });
        this.preLoader = false;
        return;
      }

      if (custom == true) {
        if (this.dates == "") {
          this.$swal({
            type: "error",
            title: "Sorry",
            text: "You need to select a date to continue."
          });
          this.preLoader = false;
          return;
        }
      }

      var endTimeCal = moment(itemObj.endTime, ["HH:mm"]).format("DD/MM/YYYY HH:mm:ss");
      var startTimeCal = moment(itemObj.startTime, ["HH:mm"]).format("DD/MM/YYYY HH:mm:ss");

      var duration = moment(endTimeCal, "DD/MM/YYYY HH:mm").diff(
        moment(startTimeCal, "DD/MM/YYYY HH:mm")
      );

      var tempTimeDuration = moment.duration(duration);

      var durInMin = tempTimeDuration.asMinutes();

      if (duration == 0) {
        this.$swal({
          type: "error",
          text: "Shift start and end time cannot be same"
        });
        this.preLoader = false;
        return;
      }

      var calculatedTime = durInMin + itemObj.bufferTime * 2;

      if (durInMin < 0) {
        // alert("If")

        if (calculatedTime >= 0) {
          this.$swal({
            type: "error",
            text: "Shift duration + buffer time cannot be more than 24 hours"
          });
          this.preLoader = false;
          return;
        }
      } else if (durInMin > 0) {
        if (calculatedTime >= 1440) {
          this.$swal({
            type: "error",
            text: "Shift duration + buffer time cannot be more than 24 hours"
          });
          this.preLoader = false;
          return;
        }
      }

      if (this.editedIndex > -1) {
        // write item update code

        const updateObj = {
          name: itemObj.name,
          startTime: itemObj.startTime,
          endTime: itemObj.endTime,
          bufferTime: itemObj.bufferTime,
          companyId: itemObj.companyId,
          custom,
          customDates,
          exceptions
        };

        this.$http.patch(`${this.$store.state.endpoint}shifts/${itemObj.id}`, updateObj).then(
          response => {
            // success callback
            this.$refs.shiftRules.resetValidation();

            this.getShiftData();

            fb.log("shift_updated");
          },
          error => {
            console.log(error);
            // error callback
            this.preLoader = false;
            this.$swal({
              type: "error",
              title: "Oops",
              text: "Something went wrong. Try again later."
            });
          }
        );
      } else {
        const self = this;

        const insertObj = {
          name: itemObj.name,
          startTime: itemObj.startTime,
          endTime: itemObj.endTime,
          companyId: itemObj.companyId,
          bufferTime: itemObj.bufferTime,
          custom,
          customDates,
          exceptions
        };

        if (custom == true) {
          if (self.dates == "") {
            self.$swal({
              type: "error",
              title: "Sorry",
              text: "You need to select a date to continue."
            });
            this.preLoader = false;
            return;
          }
        }
        // else if(self.selectedDayOccurence == "" ){
        //     self.$swal({
        //         type: 'error',
        //         text: 'Please fill the required fields'
        //       })
        //     this.preLoader = false
        //     return
        // }

        if (insertObj.startTime == insertObj.endTime) {
          this.$swal({ type: "warning", text: "Start and end time cannot be same" });
          this.preLoader = false;
          return;
        }

        // validation for shift name occurrence
        for (const x in self.shifts) {
          if (insertObj.name.toLowerCase() == this.shifts[x].name.toLowerCase()) {
            this.$swal({ type: "warning", text: "Enter a different shift name" });
            this.preLoader = false;
            return;
          }
        }

        this.$http.post(`${this.$store.state.endpoint}shifts`, insertObj).then(
          response => {
            this.selectedDayOccurence = [];

            this.day = "";
            this.occurence = "";

            this.dates = [];
            this.switch1 = false;
            this.$refs.shiftRules.resetValidation();

            this.getShiftData();

            fb.log("shift_added");
          },
          error => {
            console.log(error);
            // error callback
            this.preLoader = false;
            this.$swal({
              type: "error",
              title: "Oops",
              text: "Something went wrong. Try again later."
            });
          }
        );
      }
      this.close();
    }
  }
};
</script>
<style scoped></style>
